import React from "react";

import Layout from '@components/layout';
import ContractTypesTemplate from "@components/contractTypesPage/contractTypesTemplate";

const IndexPage = ({ pageContext }) => (
  <Layout locale={pageContext.locale}>
    <ContractTypesTemplate pageContext={pageContext} />
  </Layout>
);

export default IndexPage;
